import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React, { useState } from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./SelectStatesBottomSheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import {
  captureInterest,
  setSelectedStateAction,
} from "@src/components/Tabs/Overview/store/actions.js";
import { initialisePaymentService } from "@src/PaymentService";
import { newWebEngage } from "@src/utils/webEngageEvent";
import PrepurchageIdfys from "../../../Tabs/Overview/components/idfys/prepurchageIdfys/PrepurchageIdfys";

const SelectStatesBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
    const [isIdfyEmailVerificationEnabled, setIsIdfyEmailVerificationEnabled] = useState(false);
    const isPaymentCancel = useSelector((state) => state.bottomSheetReducer?.isIdysPaymentRejected);
  const statesList = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.states
  );
  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );
  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );
  const enablePrefilledState = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.enablePrefilledState
  );
  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showSelectStateBottomSheet
  );
  // console.log(statesList);
  const selectedState = useSelector(
    (state) => state?.overviewReducer?.stateSelected
  );
  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );
  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const inputChangedHandler = (e) => {
    // console.log("value", e.target.value);
    if (!enablePrefilledState) {
      window?.localStorage?.setItem("stateSelected", e.target.value);
    }
    dispatch(setSelectedStateAction(e.target.value));
  };

  const setAsDefaultHandler = (e) => {
    window?.webkit?.messageHandlers?.performAction?.postMessage(
      JSON.stringify({
        screen: "SELECT_DEFAULT_STATE",
        paramOne: selectedState,
      })
    );

    window?.mobile?.performAction?.(
      `SELECT_DEFAULT_STATE`,
      JSON.stringify({ paramOne: selectedState })
    );

    // console.log("first", e.target.checked);
  };
  const handleBuyNow = () => {
    // console.log(selectedState);
    if (selectedState && purchaseViaWhatsapp) {
      const payload = {
        courseId: courseId,
        courseName: overViewData?.details?.name,
      };
      newWebEngage("course_interested_whatsapp_click", {
        sub_source_id: courseId,
      });
      dispatch(captureInterest(payload));
    } else if (selectedState && isComboActive) {
      dispatch(actionCreator.courseFacultyListModalAction(true));
      dispatch(actionCreator.showSelectStateBottomSheetAction(false));
    } else if (selectedState) {
      dispatch(actionCreator.showSelectStateBottomSheetAction(false));
      initialisePaymentService();
    } else {
      toast("Please select a state");
    }
  };
  const handlePaymentSucess = () => {
    dispatch(actionCreator.showSelectStateBottomSheetAction(false));
    initialisePaymentService();
  }

  const handleIfdyBuy = () => {
     if(overViewData?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired) {
        setIsIdfyEmailVerificationEnabled(true);
      }else{
        handleBuyNow();
      }
  }
  return (
    <div className={styles.AllStates}>
      {isIdfyEmailVerificationEnabled ? (<PrepurchageIdfys setIsIdfyEmailVerificationEnabled={setIsIdfyEmailVerificationEnabled} handlePaymentSucess={handlePaymentSucess} />) : null}
      <Modal
        showModal={state}
        handleClose={() => {
          dispatch(actionCreator.showSelectStateBottomSheetAction(false));
        }}
        header={
          <div className={styles.AllStates__header}>
            <Image
              src={getAwsAssets("locationIcon.svg", "bottomSheets")}
              alt={t(
                "components.bottomSheets.components.selectStateBottomSheet.locationIcon",
                "locationIcon"
              )}
              width="28px"
              height="28px"
            />
            {t(
              "components.bottomSheets.components.selectStateBottomSheet.selectState",
              "Select State"
            )}
          </div>
        }
      >
        <div className={styles.AllStates__States}>
          <p className={styles.AllStates__States__detail}>
            {t(
              "components.bottomSheets.components.selectStateBottomSheet.gstPaymentInvoice",
              "We require this to send you a GST payment invoice."
            )}
          </p>
          <h1 className={styles.AllStates__States__heading}>
            {t(
              "components.bottomSheets.components.selectStateBottomSheet.allStateUnionTerritories",
              "All States/Union Territories"
            )}
          </h1>
          <div className={styles.AllStates__States__StateList}>
            {statesList?.map((item, idx) => {
              return (
                <label
                  className={styles.AllStates__States__StateList__item}
                  key={idx}
                  htmlFor={item.name}
                >
                  <p>{item.name}</p>
                  <input
                    type="radio"
                    name="selectedState"
                    id={item.name}
                    value={item.name}
                    checked={item.name === selectedState}
                    onChange={inputChangedHandler}
                  />
                </label>
              );
            })}
          </div>
        </div>
        {selectedState ? (
          <div
            className={
              styles.AllStates__ModalFooter +
              (enablePrefilledState ? " " + styles.fullWidthButton : "")
            }
          >
            {!enablePrefilledState && (
              <>
                <input
                  type="checkbox"
                  name="default"
                  id="default"
                  onChange={setAsDefaultHandler}
                />
                <label htmlFor="default">
                  {t(
                    "components.bottomSheets.components.selectStateBottomSheet.setAsDefault",
                    "Set as default"
                  )}
                </label>
              </>
            )}
            <Button onClick={() =>isPaymentCancel ? handleBuyNow() : handleIfdyBuy()}>
              {purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1 ? 
                t(
                  "components.bottomSheets.components.selectStateBottomSheet.proceed",
                  "Proceed"
                ) : t(
                  "components.bottomSheets.components.selectStateBottomSheet.proceedToPayment",
                  "Proceed to Payment"
                )}
            </Button>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default SelectStatesBottomSheet;
